import { useState } from "react";
import { toast } from "sonner";
import { uploadMedia } from "../lib/api";

/**
 * Shared file-input upload boilerplate: extracts the file, tracks a busy key
 * (so multiple upload widgets on the same page can each show their own
 * "Subiendo..." state), uploads via the object storage API, and always
 * resets the file input afterwards.
 */
export const useMediaUpload = () => {
  const [busyKey, setBusyKey] = useState(null);

  const upload = async (e, { type, key, successMessage, errorMessage, onSuccess }) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusyKey(key);
    try {
      const { url } = await uploadMedia(file, type);
      onSuccess(url);
      if (successMessage) toast.success(successMessage);
    } catch {
      toast.error(errorMessage);
    } finally {
      setBusyKey(null);
      e.target.value = "";
    }
  };

  return { busyKey, upload };
};
